import { z } from 'zod';

import type { PetitionEditPageData, PetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';

/**
 * While `image` is the only media type that is supported currently,
 * capturing the final value will be handled during the api request when the url is resolved on form submit.
 *
 * Thus the only usage of `formState` here is to populate the initial value or remove an existing image.
 * If the user decides to change the image, the value will then be handed off to `uppy`,
 * a library we use to upload a cropped image to AWS S3.
 *
 * TODO: either when video is added or the petition update request supports cropping data
 * we will need to begin storing and validating the newly accepted inputs
 */

// formState zod schema
export const mediaSchema = z.nullable(z.object({}).optional());

// transform petition GET API data to formState structure
type FormStateMedia = PetitionEditPageState['formState']['media'];
export const deserializeMedia = ({ petition }: Pick<PetitionEditPageData, 'petition'>): FormStateMedia => {
	const photoMedia = petition.photo?.petitionMedium.url
		? {
				type: 'photo' as const,
				url: petition.photo.petitionMedium.url,
				processing: petition.photo.petitionMedium.processing,
				tag: petition.photo.petitionMedium.tag,
			}
		: undefined;

	return {
		value: photoMedia,
		error: null,
		dirty: false,
	};
};

// transform formState structure to petition PUT API data
export const serializeMedia = (val: z.infer<typeof mediaSchema>) => (val === null ? null : {});
